// Categorical order of the validated reference palette: assign in this order, never cycled.
// Past what a chart can tell apart, fold the remaining series into OTHER_SERIES_COLOR.
export const CATEGORICAL_COLORS = [
  '#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948',
];

// Neutral steps for folded or ranked-out series ("Other").
export const NEUTRAL_SERIES_COLOR = '#8a8984';
export const OTHER_SERIES_COLOR = '#c3c2bd';
